import React from 'react';
import { observer } from 'mobx-react';
import { withNamespaces } from 'react-i18next';
import PropTypes from 'prop-types';

import { routeNode } from 'core/routing';

import { FourOhFour } from 'apps/fourOhFour/index';

import { ChannelAppManager } from 'apps/channel/main/appManager';
import { Channel } from 'apps/channel/main/index';

import DocumentHead from 'legacyComponents/documentHead';
import { MainWrapper } from 'legacyComponents/styled/lib';
import Header from 'apps/components/header/header';
import { Loading } from 'libs/rendering/gltf/components/loading';
import { ChannelOverview } from 'apps/channel/views/overview';
import { Competiton } from 'apps/channel/competiton/index';
import { ChannelLanding } from 'apps/channel/landing';
import { ChannelStories } from 'apps/channel/main/stories';
import { ChannelThreads } from 'apps/channel/main/threads';
import { ChannelCollections } from 'apps/channel/main/collections';
// import { ChannelSettingsRouter } from 'apps/channel/settings/router';

const viewsMap = {
  '': Channel,
  stories: ChannelStories,
  threads: ChannelThreads,
  collections: ChannelCollections,
  // settings: ChannelSettingsRouter,
};

@withNamespaces()
@observer
class ChannelSpace extends React.Component {
  UNSAFE_componentWillMount() {
    this.appManager = new ChannelAppManager(null, this.props.route);
  }

  render() {
    if (this.appManager.notFound) {
      return <FourOhFour type='Channel' />;
    }

    const { channel } = this.appManager;
    if (!channel || this.appManager.loading) {
      return (
        <>
          <DocumentHead title={`${'Loading...'}`} />
          <Header />
          <Loading visible noText />
        </>
      );
    }

    const index = 'noindex';
    // set index to 'index' if we have unique body text for the channel

    if (channel?.isCompetition && channel.story) {
      return (
        <>
          <DocumentHead
            title={`#${this.props.route.params.channel}`}
            description={null}
            index={index}
          />
          <Header />
          <Competiton
            appManager={this.appManager}
            params={this.props.route.params}
          />
        </>
      );
    }

    if (channel?.isLanding && channel.story) {
      return (
        <>
          <DocumentHead
            title={`#${this.props.route.params.channel}`}
            description={null}
            index={index}
          />
          <Header />
          <ChannelLanding
            appManager={this.appManager}
            params={this.props.route.params}
          />
        </>
      );
    }

    const {
      threadsConn,
      projectsConn,
      storiesConn,
      collectionsConn,
    } = this.appManager;

    const View = this.props.componentFromRoute();
    return (
      <>
        <DocumentHead
          title={`#${this.props.route.params.channel}`}
          description={null}
          index={index}
        />
        <Header />
        <MainWrapper>
          <ChannelOverview
            appManager={this.appManager}
            channelName={this.props.route.params.channel}
          />
          <View
            params={this.props.routerStore.params}
            // appManager={this.appManager}
            projects={projectsConn.arrayApp}
            stories={storiesConn.arrayApp}
            threads={threadsConn.arrayApp}
            collections={collectionsConn.arrayApp}
          />
        </MainWrapper>
      </>
    );
  }
}

ChannelSpace.propTypes = {
  route: PropTypes.object,
  routerStore: PropTypes.object,
  componentFromRoute: PropTypes.func,
};

export const ChannelRouter = routeNode(
  'channel',
  viewsMap,
  FourOhFour,
)(ChannelSpace);
